import { useQuery } from "@tanstack/react-query";

import { ApiResponse } from "../../apis/data";
import { queryKey } from "../../enumerations/queryKey";
import { PhoneCodeResponse } from "./data";
import { apiGetAreaCode } from "./service";

export const useGetAreaCode = (options: any) => {
  return useQuery<PhoneCodeResponse[]>({
    queryKey: [queryKey.PHONE_CODE],
    queryFn: () =>
      apiGetAreaCode().then(
        (res: ApiResponse<PhoneCodeResponse[]>) => res.data
      ),
    ...options,
  });
};
